import React, {useEffect, useState} from "react";
import Head from "next/head";
import styled from "styled-components";
import ButtonLink from "@atoms/button.link";
import {isEmpty, str_replace} from "../components/helpers/helpers";
import {getDefaultCity} from "../components/hooks/cities";

export default function NotFound() {
    const [url, setUrl] = useState(null);
    const defaultCity = getDefaultCity(true);

    const handleBrandUrl = () => {
        let url = '/';

        if (!isEmpty(defaultCity)) {
            url += 'املاک-' + str_replace(' ', '-', defaultCity.name);
        }

        setUrl(url);
    };

    useEffect(() => {
        handleBrandUrl();
    }, [url]);

    return (
        <React.Fragment>
            <Head>
                <title>خطای 404</title>
                <meta name="robots" content="NOODP, nofollow, noindex"/>
            </Head>

            <Container className="text-center d-flex flex-column align-items-center justify-content-center">
                <img className="mb-40 mb-lg-56" width="560" src="/_img/errors/404.png"/>

                <p class="h2 px-24">
                    <span class="text-secondary">خطای 404</span>
                    <span> - انگار آدرس رو اشتباه اومدین!</span>
                </p>

                <p className="h4-normal">برای پیدا کردن آدرس درست، بهتره به صفحه اول<br className="d-md-none"/> مراجعه کنین.</p>

                <ButtonLink href={(!isEmpty(defaultCity) ? '/properties' : '/')} hrefAs={url} color="secondary" className="mt-16">
                    صفحه اول 2نبش
                </ButtonLink>
            </Container>
        </React.Fragment>
    )
}

// styles

const Container = styled.div`
	height: 100vh;

	@media (max-width: ${props => props.theme.screenXsMax}) {
		padding: 0 8px;
		img {
			width: 300px;
		}
	 }
`;